import React, { useEffect, useState } from "react";
import {
  getAchievements,
  Achievements as AchievementsType,
} from "../../firebase/achievements";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Achievement from "./Achievement";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";
import CommunicationOfficerIcon from "./svg/communication-officer.svg";
import CommunicationOfficerDisabledIcon from "./svg/communication-officer-disabled.svg";
import LikeScavengerIcon from "./svg/like-scavenger.svg";
import LikeScavengerDisabledIcon from "./svg/like-scavenger-disabled.svg";
import StatementTrackerIcon from "./svg/statement-tracker.svg";
import StatementTrackerDisabledIcon from "./svg/statement-tracker-disabled.svg";
import VotingSpecialistIcon from "./svg/voting-specialist.svg";
import VotingSpecialistDisabledIcon from "./svg/voting-specialist.svg";

const useStyles = makeStyles({
  achievementsContainer: {
    backgroundColor: colors.BACKGROUND_SECONDARY,
    textAlign: "center",
    paddingTop: "30px",
  },
  title: {
    fontSize: "32px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "2.66",
    letterSpacing: "-0.06px",
    color: colors.TEXT_PRIMARY,
  },
});

export default function Achievements({ userId }: { userId: string }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [achievements, setAchievements] = useState<AchievementsType | null>(
    null
  );

  useEffect(() => {
    async function fetch() {
      const achievements = await getAchievements(userId);
      setAchievements(achievements);
    }
    fetch();
  }, [userId]);

  if (!achievements) return null;

  return (
    <Grid container item className={classes.achievementsContainer}>
      <Grid item xs={12}>
        <span className={classes.title}>{t("achievements.title")}</span>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Achievement
          title={t("achievements.comments_title")}
          description={t("achievements.comments_description", {
            count: achievements.comments.count,
            target: achievements.comments.target,
          })}
          achievement={achievements.comments}
          icon={
            achievements.comments.achieved
              ? CommunicationOfficerIcon
              : CommunicationOfficerDisabledIcon
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Achievement
          title={t("achievements.likes_title")}
          description={t("achievements.likes_description", {
            count: achievements.likes.count,
            target: achievements.likes.target,
          })}
          achievement={achievements.likes}
          icon={
            achievements.likes.achieved
              ? LikeScavengerIcon
              : LikeScavengerDisabledIcon
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Achievement
          title={t("achievements.follows_title")}
          description={t("achievements.follows_description", {
            count: achievements.follows.count,
            target: achievements.follows.target,
          })}
          achievement={achievements.follows}
          icon={
            achievements.follows.achieved
              ? StatementTrackerIcon
              : StatementTrackerDisabledIcon
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Achievement
          title={t("achievements.votes_title")}
          description={t("achievements.votes_description", {
            count: achievements.votes.count,
            target: achievements.votes.target,
          })}
          achievement={achievements.votes}
          icon={
            achievements.votes.achieved
              ? VotingSpecialistIcon
              : VotingSpecialistDisabledIcon
          }
        />
      </Grid>
    </Grid>
  );
}
